if (!customElements.get('modal-carousel')) {
  class ModalCarousel extends HTMLElement {
    constructor() {
      super();
      this._onPrev = () => this.currentSlideIndex = this.currentSlideIndex - 1;
      this._onNext = () => this.currentSlideIndex = this.currentSlideIndex + 1;
      this._onKey = (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.currentSlideIndex--; }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.currentSlideIndex++; }
      };
    }

    get currentSlideIndex() {
      return Number(this.dataset.index || 0);
    }

    set currentSlideIndex(idx) {
      const clamped = Math.max(0, Math.min((this.total || 0) - 1, Number(idx)));
      if (!Number.isFinite(clamped)) return;
      if (clamped === this.currentSlideIndex) return;

      // slides
      this.slides.forEach((el, i) => {
        if (i === clamped) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });

      // thumbs
      this.thumbs.forEach((btn, i) => {
        if (i === clamped) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        }
      });

      // nav state
      if (this.prevBtn) this.prevBtn.disabled = clamped === 0;
      if (this.nextBtn) this.nextBtn.disabled = clamped === this.total - 1 || this.total <= 1;

      // reflect + SR announce
      this.dataset.index = String(clamped);
      if (this.stage) {
        this.stage.setAttribute('aria-busy', 'true');
        requestAnimationFrame(() => this.stage && this.stage.removeAttribute('aria-busy'));
      }
    }

    connectedCallback() {
      // refs
      this.stage  = this.querySelector('.vbb-carousel__stage');
      this.slides = Array.from(this.querySelectorAll('.vbb-carousel__slide'));
      this.prevBtn = this.querySelector('.vbb-carousel__nav--prev');
      this.nextBtn = this.querySelector('.vbb-carousel__nav--next');
      this.thumbs = Array.from(this.querySelectorAll('.vbb-carousel__thumb'));
      this.total = this.slides.length;

      // init
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
      this.currentSlideIndex = this.currentSlideIndex; // apply initial UI
      if (this.prevBtn) this.prevBtn.disabled = this.currentSlideIndex === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.total <= 1 || this.currentSlideIndex === this.total - 1;

      // events
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);
      this.thumbs.forEach(btn => {
        btn.addEventListener('click', () => {
          this.currentSlideIndex = Number(btn.dataset.idx);
        });
      });
      this.addEventListener('keydown', this._onKey);

      this.container = this.dataset.container;
      this.productForm = this.closest(this.container);
      this.productForm.addEventListener('variant:selected', (e) => {
        const variantId = e.detail?.variantId;
        const selectorId = this.getAttribute('data-container');
        if (!variantId || !selectorId) return;

        // // Find the carousel for the new variant
        const newCarousel = this.productForm.querySelector(`:scope template[data-variant="${variantId}"]`);
        this.replaceWith(newCarousel.content.cloneNode(true));
      });
    }
    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
      this.thumbs?.forEach(btn => btn.replaceWith(btn)); // quick unbind
      this.removeEventListener('keydown', this._onKey);
    }
  }

  customElements.define('modal-carousel', ModalCarousel);
}

